import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { MessageType, TranslationStatus } from "../common/Exports";
import { CancellationErrorCode, CancellationReason, PropertyCollection, PropertyId, ResultReason, TranslationRecognitionCanceledEventArgs, TranslationRecognitionEventArgs, TranslationRecognitionResult, Translations, TranslationSynthesisEventArgs, TranslationSynthesisResult } from "../sdk/Exports";
import { CancellationErrorCodePropertyName, EnumTranslation, RecognitionStatus, ServiceRecognizerBase, SynthesisStatus, TranslationHypothesis, TranslationPhrase, TranslationSynthesisEnd } from "./Exports"; // tslint:disable-next-line:max-classes-per-file

export var TranslationServiceRecognizer = /*#__PURE__*/function (_ServiceRecognizerBas) {
  _inherits(TranslationServiceRecognizer, _ServiceRecognizerBas);

  function TranslationServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer) {
    var _this;

    _classCallCheck(this, TranslationServiceRecognizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TranslationServiceRecognizer).call(this, authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer));
    _this.privTranslationRecognizer = translationRecognizer;
    return _this;
  }

  _createClass(TranslationServiceRecognizer, [{
    key: "processTypeSpecificMessages",
    value: function processTypeSpecificMessages(connectionMessage, successCallback, errorCallBack) {
      var resultProps = new PropertyCollection();
      var processed = false;

      if (connectionMessage.messageType === MessageType.Text) {
        resultProps.setProperty(PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
      }

      switch (connectionMessage.path.toLowerCase()) {
        case "translation.hypothesis":
          var result = this.fireEventForResult(TranslationHypothesis.fromJSON(connectionMessage.textBody), resultProps);
          this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + result.offset);

          if (!!this.privTranslationRecognizer.recognizing) {
            try {
              this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, result);
              /* tslint:disable:no-empty */
            } catch (error) {// Not going to let errors in the event handler
              // trip things up.
            }
          }

          processed = true;
          break;

        case "translation.phrase":
          var translatedPhrase = TranslationPhrase.fromJSON(connectionMessage.textBody);
          this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset + translatedPhrase.Duration);

          if (translatedPhrase.RecognitionStatus === RecognitionStatus.Success) {
            // OK, the recognition was successful. How'd the translation do?
            var _result = this.fireEventForResult(translatedPhrase, resultProps);

            if (!!this.privTranslationRecognizer.recognized) {
              try {
                this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, _result);
                /* tslint:disable:no-empty */
              } catch (error) {// Not going to let errors in the event handler
                // trip things up.
              }
            } // report result to promise.


            if (!!successCallback) {
              try {
                successCallback(_result.result);
              } catch (e) {
                if (!!errorCallBack) {
                  errorCallBack(e);
                }
              } // Only invoke the call back once.
              // and if it's successful don't invoke the
              // error after that.


              successCallback = undefined;
              errorCallBack = undefined;
            }

            break;
          } else {
            var reason = EnumTranslation.implTranslateRecognitionResult(translatedPhrase.RecognitionStatus);

            var _result2 = new TranslationRecognitionResult(undefined, this.privRequestSession.requestId, reason, translatedPhrase.Text, translatedPhrase.Duration, this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset, undefined, connectionMessage.textBody, resultProps);

            if (reason === ResultReason.Canceled) {
              var cancelReason = EnumTranslation.implTranslateCancelResult(translatedPhrase.RecognitionStatus);
              this.cancelRecognitionLocal(cancelReason, EnumTranslation.implTranslateCancelErrorCode(translatedPhrase.RecognitionStatus), undefined, successCallback);
            } else {
              if (!(this.privRequestSession.isSpeechEnded && reason === ResultReason.NoMatch && translatedPhrase.RecognitionStatus !== RecognitionStatus.InitialSilenceTimeout)) {
                var ev = new TranslationRecognitionEventArgs(_result2, _result2.offset, this.privRequestSession.sessionId);

                if (!!this.privTranslationRecognizer.recognized) {
                  try {
                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
                    /* tslint:disable:no-empty */
                  } catch (error) {// Not going to let errors in the event handler
                    // trip things up.
                  }
                }
              } // report result to promise.


              if (!!successCallback) {
                try {
                  successCallback(_result2);
                } catch (e) {
                  if (!!errorCallBack) {
                    errorCallBack(e);
                  }
                } // Only invoke the call back once.
                // and if it's successful don't invoke the
                // error after that.


                successCallback = undefined;
                errorCallBack = undefined;
              }
            }
          }

          processed = true;
          break;

        case "translation.synthesis":
          this.sendSynthesisAudio(connectionMessage.binaryBody, this.privRequestSession.sessionId);
          processed = true;
          break;

        case "translation.synthesis.end":
          var synthEnd = TranslationSynthesisEnd.fromJSON(connectionMessage.textBody);

          switch (synthEnd.SynthesisStatus) {
            case SynthesisStatus.Error:
              if (!!this.privTranslationRecognizer.synthesizing) {
                var _result3 = new TranslationSynthesisResult(ResultReason.Canceled, undefined);

                var retEvent = new TranslationSynthesisEventArgs(_result3, this.privRequestSession.sessionId);

                try {
                  this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
                  /* tslint:disable:no-empty */
                } catch (error) {// Not going to let errors in the event handler
                  // trip things up.
                }
              }

              if (!!this.privTranslationRecognizer.canceled) {
                // And raise a canceled event to send the rich(er) error message back.
                var canceledResult = new TranslationRecognitionCanceledEventArgs(this.privRequestSession.sessionId, CancellationReason.Error, synthEnd.FailureReason, CancellationErrorCode.ServiceError, null);

                try {
                  this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, canceledResult);
                  /* tslint:disable:no-empty */
                } catch (error) {// Not going to let errors in the event handler
                  // trip things up.
                }
              }

              break;

            case SynthesisStatus.Success:
              this.sendSynthesisAudio(undefined, this.privRequestSession.sessionId);
              break;

            default:
              break;
          }

          processed = true;
          break;

        default:
          break;
      }

      return processed;
    } // Cancels recognition.

  }, {
    key: "cancelRecognition",
    value: function cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error, cancelRecoCallback) {
      var properties = new PropertyCollection();
      properties.setProperty(CancellationErrorCodePropertyName, CancellationErrorCode[errorCode]);

      if (!!this.privTranslationRecognizer.canceled) {
        var cancelEvent = new TranslationRecognitionCanceledEventArgs(sessionId, cancellationReason, error, errorCode, undefined);

        try {
          this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, cancelEvent);
          /* tslint:disable:no-empty */
        } catch (_a) {}
      }

      if (!!cancelRecoCallback) {
        var result = new TranslationRecognitionResult(undefined, // Translations
        requestId, ResultReason.Canceled, undefined, // Text
        undefined, // Druation
        undefined, // Offset
        error, undefined, // Json
        properties);

        try {
          cancelRecoCallback(result);
          /* tslint:disable:no-empty */
        } catch (_b) {}
      }
    }
  }, {
    key: "fireEventForResult",
    value: function fireEventForResult(serviceResult, properties) {
      var translations;

      if (undefined !== serviceResult.Translation.Translations) {
        translations = new Translations();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = serviceResult.Translation.Translations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var translation = _step.value;
            translations.set(translation.Language, translation.Text);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      var resultReason;

      if (serviceResult instanceof TranslationPhrase) {
        if (serviceResult.Translation.TranslationStatus === TranslationStatus.Success) {
          resultReason = ResultReason.TranslatedSpeech;
        } else {
          resultReason = ResultReason.RecognizedSpeech;
        }
      } else {
        resultReason = ResultReason.TranslatingSpeech;
      }

      var offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
      var result = new TranslationRecognitionResult(translations, this.privRequestSession.requestId, resultReason, serviceResult.Text, serviceResult.Duration, offset, serviceResult.Translation.FailureReason, JSON.stringify(serviceResult), properties);
      var ev = new TranslationRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
      return ev;
    }
  }, {
    key: "sendSynthesisAudio",
    value: function sendSynthesisAudio(audio, sessionId) {
      var reason = undefined === audio ? ResultReason.SynthesizingAudioCompleted : ResultReason.SynthesizingAudio;
      var result = new TranslationSynthesisResult(reason, audio);
      var retEvent = new TranslationSynthesisEventArgs(result, sessionId);

      if (!!this.privTranslationRecognizer.synthesizing) {
        try {
          this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
          /* tslint:disable:no-empty */
        } catch (error) {// Not going to let errors in the event handler
          // trip things up.
        }
      }
    }
  }]);

  return TranslationServiceRecognizer;
}(ServiceRecognizerBase);